<template>
  <div class="collection">
    <div class="loading" v-if="isLoading"></div>
    <div class="top-header">
      <p>{{subjectInfo.introduction || '--'}}
      </p>
    </div>
    <div class="bottom-content">
      <div class="radius"></div>
      <div class="nav">
        <ul v-if="columnlist && columnlist.length > 0">
          <li class="all" :class="isActiveTab === -1 ? 'is-active' : ''" @click="onClickAll">全部</li>
          <li v-for="(item, index) in columnlist" :key="index" :class="isActiveTab === index ? 'is-active' : ''" @click="onClickTab(item, index)">{{item.name}}</li>
        </ul>
      </div>
      <div class="list">
        <ul v-if="articleList && articleList.length > 0">
          <li v-for="(item, index) in articleList" :key="index" @click="searchDetail(item)">
            <div class="left">
              <img :id="'cover_' + index" src="../../assets/image-default.png" :data-src="getAppListImage(item)" alt="">
            </div>
            <div class="right">
              <p class="title" :class="handleClass(item)">{{item.title}}</p>
              <div class="desc">
                <span class="date barlow-regular">{{item.publishTime | formatTimeV2}}</span>
                <p v-if="getColumnName(item)" class="topic">#<span class="topic-name" v-text="getColumnName(item)"></span></p>
              </div>
            </div>
          </li>
        </ul>
        <div v-if="isWait" class="moretip">加载中</div>
        <div v-else-if="isNoData" class="no-data">
          <img src="../../assets/no-data-new.png" alt="">
          <p>暂无内容</p>
        </div>
        <div v-else-if="noMore" class="nomore moretip"><span>没有更多了</span></div>
      </div>
    </div>
    <transition name="fade">
      <div id="news-tip" @click="onClickNewsTip"><span id="newsSum"></span> 条新文章</div>
    </transition>
  </div>
</template>
<script>
import share from '@/mixins/share-finder.js'
import url from 'url'
import {mapState} from 'vuex'
import {formatTimeV2} from '@/filters/index.js'
import {fetchColumnCollection, fetchSubjectDetail, getArticleList} from '@/api/index'
import {onLoadPreImg, setDocumentTitle} from '@/utils/index'
import { rSocket } from '@/utils/socket.js'
import { clearNewsId, storeNewsId, getColumnName, getAppListImage, handleClass} from './control'
export default {
  data () {
    return {
      rSocket,
      pageSize: 30, // 文章列表分页
      columnlist: [],
      subjectInfo: {},
      articleList: [],
      columnCodesList: [],
      querys: {},
      isLoading: false,
      noMore: false,
      isWait: false,
      isActiveTab: -1,
      msg: '',
      columnCodes: '',
      isNoData: false,
      documentTitle: ''
    }
  },
  computed: {
    ...mapState(['serviceConfig', 'wechatUser']),
  },
  mixins: [share],
  watch: {
    wechatUser: {
      async handler(val) {
        let {appCode} = this.serviceConfig
        const { 
          token, 
          username, 
        } = val
        let _this = this
        if (token && username) {
          await rSocket.socketInit({username, appCode}, _this.getSocketMessage)
          this.$route.meta.sendSocket && rSocket.socketSend({type: 5, topic: 'news:h5:newsPage' })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  beforeDestroy () {
    localStorage.removeItem('curTab')
    this.$route.meta.sendSocket && rSocket.socketSend({type: 6, topic: 'news:h5:newsPage' })
  },
  mounted () {
    clearNewsId('recentNewsId')
    document.getElementById('app').style.backgroundColor = '#fff'
    this.init()
    this.initLoadMore()
  },
  filters: {
    formatTimeV2
  },
  methods: {
    getAppListImage,
    getColumnName,
    handleClass,
    onClickNewsTip () {
      this.showTip(false)
      clearNewsId('recentNewsId')
      if (this.isActiveTab === -1) {
        this.onClickAll()
      } else {
        let item = {
          code: this.columnCodes,
        }
        let index = this.columnCodesList.indexOf(this.columnCodes)
        this.onClickTab(item, index)
      }
    },
    showTip(flag) {
      const newsEle = document.getElementById('news-tip')
      newsEle.style.display = flag ? 'block' : 'none'
    },
    updateNewsSum (len) {
      const textDom = document.getElementById('newsSum')
      textDom.innerText = len
    },
    onShowNewsTip (len) {
      this.showTip(true)
      this.updateNewsSum(len)
    },
    getSocketMessage (info) {
      let { message } = info
      message = JSON.parse(message) || {}
      console.log('message: ', message,)
      let {appCodes, columnCodes, newsId} = message || {}
      if (appCodes.includes(this.serviceConfig.appCode)) {
        let codelist = this.columnCodes.split(',')
        let flag = columnCodes.find(code => {
          return codelist.includes(code)
        })
        if (!flag) return
        storeNewsId(newsId, 'recentNewsId')
        let list = localStorage.getItem('recentNewsId')
        list = JSON.parse(list)
        let len = list.length
        if (len > 0) {
          const _this = this
          let timer = setTimeout(function () {
            clearTimeout(timer)
            timer = null
            _this.onShowNewsTip(len)
          }, 5000)
        }
      }
    },
    initLoadMore () {
      window.addEventListener('scroll', (e) => {
        let dom = e.srcElement || e.target
        if (this.noMore || this.isWait) return
        const {clientHeight, scrollHeight, scrollTop} = dom
        if (scrollTop + clientHeight >= scrollHeight - 100) {
          this.getArticleList(this.columnCodes)
        }
      }, true)
    },
    async init () {
      this.initQuery()
      this.getColumnList()
      this.getSubjectDetail()
    },
    initQuery () {
      let querys = url.parse(window.location.toString(), true).query
      this.querys = querys
    },
    onClickAll () {
      this.$sa.track('switch_subject_page', {
        subject_id: this.querys.subjectCode,
        subject_name: this.documentTitle,
        tab_title: '全部',
        channel_id:this.querys.channel_id||""
      })
      this.articleList = []
      this.noMore = false
      this.isActiveTab = -1
      this.columnCodes = this.columnCodesList.join(',')
      if (!this.columnCodes) {
        this.$toast('栏目获取失败～')
        return
      }
      this.getArticleList(this.columnCodes)
    },
    onClickTab (item, index) {
      const {code = '', name = ''} = item
      this.$sa.track('switch_subject_page', {
        subject_id: this.querys.subjectCode,
        subject_name: this.documentTitle,
        tab_title: name,
        channel_id:this.querys.channel_id||""
      })
      this.columnCodes = code
      this.isActiveTab = index
      this.articleList = []
      this.noMore = false
      this.getArticleList(code)
    },
    async getColumnList () {
      let {appCode, channel} = this.serviceConfig
      let {subjectCode = ''} = this.querys
      let params = {
        pageNo: 1,
        pageSize: 50,
        appCode,
        channel,
        subCodeList: [subjectCode]
      }
      this.isLoading = true
      let {code, data} = await fetchColumnCollection(params) || {}
      this.isLoading = false
      // console.log('获取栏目集合接口： ', data)
      if (code !== 1) {
        this.$toast(`系统异常，请稍后再试${code || ''}～`)
        return
      }
      let columnlist = (data || {}).data
      this.columnlist = columnlist
      this.total = (data || {}).total
      let columnCodesList = columnlist.map(item => item.code)
      this.columnCodesList = columnCodesList
      let columnCodes = columnCodesList.join(',')
      this.columnCodes = columnCodes
      this.getArticleList(columnCodes)
    },
    async getSubjectDetail () {
      let {channel, image} = this.serviceConfig
      let {subjectCode = ''} = this.querys
      let params = {
        channel,
        subCode: subjectCode
      }
      this.isLoading = true
      let {code, data} = await fetchSubjectDetail(params) || {}
      this.isLoading = false
      // console.log('获取专题详情接口： ', data)
      if (code !== 1) {
        this.$toast(`系统异常，请稍后再试${code || ''}～`)
        return
      }
      this.subjectInfo = data || {}
      const documentTitle = (data || {}).name || ''
      this.documentTitle = documentTitle
      this.$sa.track('enter_subject_page', {
        subject_id: subjectCode,
        subject_name: documentTitle,
        channel_id:this.querys.channel_id||""
      })
      setDocumentTitle(documentTitle)
      //分享信息
      this.$store.dispatch('set_share_info', {
        title: this.subjectInfo.name || '',
        desc: this.subjectInfo.introduction,
        link: window.location.href,
        imgUrl: this.subjectInfo.imageUrl || image,
        cb: this.onMenuShare
      })
      
    },
    async getArticleList(columnCodes) {
      if (!columnCodes) return
      this.isWait = true
      let {token} = this.wechatUser
      let params = {
        columnCodes,
        appCode: this.serviceConfig.appCode,
        showPermission: 9,
        direction: 'DOWN',
        end: new Date().getTime(),
        limit: this.pageSize,
        hasTop: 1,
        token
      }
      if (this.articleList.length > 0) {
        params.sortTimestamp = this.articleList[this.articleList.length-1].sortTimestamp
      }
      let res
      try {
        res = await getArticleList(params)
        // console.log('获取文章接口：', res)
      } catch (e) {
        this.$toast(e.message)
      }
      this.isWait = false
      let result = res && res.data || {}
      if (result.code !== 1) {
        this.$toast(`系统异常，请稍后再试${result.code}～`)
        return
      }
      let tmpList = result.data.slice(0, this.pageSize)
      tmpList = tmpList.map(item => {
        let coverImage = this.getAppListImage(item)
        return {
          ...item,
          coverImage
        }
      })
      if (this.articleList.length > 0 && tmpList.length <= 0) {
        this.noMore = true
        this.msg = '没有更多了'
        return
      }
      if (this.articleList.length === 0) {
        this.articleList = tmpList
      } else {
        this.articleList = this.articleList.concat(tmpList)
      }
      this.isNoData = this.articleList.length <= 0
      if (this.articleList && this.articleList.length > 0) {
        onLoadPreImg(this.articleList, 'coverImage')
      }
    },
    searchDetail(item) {
      let {newsId} = item
      storeNewsId(newsId, 'isReadedList')
      this.$router.push({
        path: `/launcher-article/${item.newsId}`,
        query: {
          columnName: item.columnCode,
          source: 'column',
          page_source: 'column_page',
          channel_id: this.querys.channel_id || ''
        }
      })
    },
  }
}
</script>
<style lang="stylus" scoped>
  .loading {
    position: fixed;
    width: 100%;
    height: 100vh;
    background: url('../../assets/loading.gif') no-repeat center;
    background-size: .8rem;
    z-index: 1;
    top: 0;
    background-color: rgba(255,255,255,.5);;
  }
  #news-tip {
    display: none;
    position: fixed;
    left: 50%; 
    bottom: 1rem;
    transform: translateX(-50%);
    font-size: .3rem;
    background: #333333;
    border-radius: .2rem;
    padding: .26rem .44rem;
    color: #fff;
  }
  .fade-enter-active{
    animation: fadeIn .5s;
  }
  @keyframes fadeIn {
    0% {
      opacity: 0
    }
    70% {
      opacity: 1
    }
    100% {
      opacity: 0
    }
  }
  .no-data {
    width: 4.6rem;
    height: auto;
    margin: .8rem auto 0;
    img {
      width: 100%;
      height: auto;
    }
    p {
      font-size: .3rem;
      color: #666;
      text-align: center;
    }
  }
  .top-header {
    display: flex;
    align-items: center;
    padding: 0 1.24rem 0 .36rem;
    width: 100%;
    height: 2.12rem;
    background: url(../../assets/columnCollection/title_bg.jpg) no-repeat center;
    background-size: cover;
    font-size: .3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(255, 255, 255, 0.9);
    p {
      line-height: .44rem;
      overflow:hidden;
      text-overflow: ellipsis;
      display:-webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
  .bottom-content {
    position: relative;
    .radius {
      position:absolute;
      left: 0;
      top: -.2rem;
      width: 100%;
      height: .3rem;
      background-color: #fff;
      border-top-left-radius: .24rem;
      border-top-right-radius: .24rem;
      overflow:hidden;
    }
    .nav {
      position: sticky;
      top: 0;
      left: 0;
      padding: .24rem .36rem .4rem;
      overflow-x: scroll;
      background-color: #fff;
      ul {
        display: block;
        font-size: 0;
        width: max-content;
      }
      li {
        display: inline-block;
        font-size: .28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #333333;
        padding: .14rem .24rem;
        background: #F5F5F5;
        border-radius: .08rem;
        margin-right: .16rem;
        &.is-active {
          background: rgba(252, 102, 0, .2);
          border-radius: .08rem;
          color: #FC6600;
        }
      }
    }
    .list {
      padding: 0 .38rem;
      li {
        display: flex;
        margin-bottom: .36rem;
        &:last-child {
          margin-bottom: 0;
        }
        .left {
          width: 2.3rem;
          height: 1.56rem;
          background-color: pink;
          margin-right: .3rem;
          border-radius: 6px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .right {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .title {
            font-size: .3rem;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #333333;
            overflow:hidden;
            text-overflow: ellipsis;
            display:-webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            &.is-readed {
              color: #666;
            }
          }
          .desc {
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }
          .date {
            font-size: .24rem;
            color: #666666;
            margin-right: 10px;
          }
          .topic {
            font-size: .24rem;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #1A74FF;
            .topic-name {
              color: rgba(102, 102, 102, 1);
            }
          }
        }
      }
      .moretip {
        text-align: center;
        font-size: .26rem;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #D2D2D2;
        height: 1.64rem;
        line-height: 1.64rem;
        span {
          text-align: center;
        }
      }
    }
  }
</style>